import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sensPaiement'
})
export class SensPaiementPipe implements PipeTransform {

  transform(value: string, sens: string): any {
    if (sens == 'C')
      return '- ' + value + ' €';
    else
      return value + ' €';
  }

}



// WEBPACK FOOTER //
// ./src/shared/pipes/sensPaiement.pipe.ts